<script>

import Loader from "@/components/Loader.vue";
import TrainingForm from "@/components/trainings/form/TrainingForm.vue";

export default {
    components: {TrainingForm, Loader},
    data() {
        return {
            training: {},
            loadingData: true
        }
    },
    mounted() {
        axios.get('/trainings/' + this.$route.params.id).then((response) => {
            this.training = response.data.data;
            for (let i = 0; i < this.training.images.length; i++) {
                this.training.images[i].timestamp = this.training.images[i].timestamp_formatted;
            }
            this.training.tags = this.training.tags?.map(tag => {
                return {text: tag}
            })
        }).catch(() => {
        }).finally(() => {
            this.loadingData = false;
        })
    }
}

</script>
<template>
    <div class="trainings-create">

        <loader :loading="loadingData"></loader>

        <TrainingForm v-if="!loadingData" :training="training"/>
    </div>
</template>
